/**
 * Is this URL segment shaped like a record id? (UI-06)
 *
 * Every canonical row in Ken is keyed by a UUID (§5.a — `id UUID PK`), so a
 * `$id` route segment that is not a UUID names no record and never will. The
 * six modules UI-06 covers used to hand whatever was in that slot straight to
 * a detail request: `/accounts/new` produced `GET /api/modules/accounts/new`,
 * a 422, and a blank screen.
 *
 * Checked in the route's `beforeLoad`, this stops the request being issued at
 * all rather than rendering an error after it fails — which is the difference
 * between "the page says no such record" and "the page is white and the
 * network tab has a 422 in it".
 *
 * Deliberately shape-only. Whether a well-formed id exists is the API's
 * question and it answers it with a 404; this is about segments that could
 * never be an id in the first place.
 */

const UUID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isRecordId(segment: string | undefined | null): boolean {
  return typeof segment === "string" && UUID.test(segment);
}
